import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Coins, Star, TrendingUp, ArrowRight, Users } from "lucide-react";

const cards = [
  {
    icon: Coins,
    title: "Earn Zeel Coins",
    description: "Votes, reviews, and shared routines earn Zeel coins. Helpful contributions unlock rewards and recognition.",
    footer: "Vote, review, share → earn coins",
    footerColor: "text-amber-600",
  },
  {
    icon: Star,
    title: "Build Your Reputation",
    description: "Earn badges as you contribute reviews, votes, and routines. Badges highlight your expertise and activity in the community.",
    footer: "5 reviews = your first badge",
    footerColor: "text-[#5B6BA8]",
  },
  {
    icon: TrendingUp,
    title: "Top Contributors",
    description: "See how your insights rank against others in the community. Top contributors get featured and recognized.",
    footer: "Top 10 get featured weekly",
    footerColor: "text-emerald-600",
  },
];

export const CommunityRewards = () => (
  <section className="py-20 px-4" style={{ background: 'linear-gradient(150deg, #3E4A98 0%, #4A55A6 20%, #5C65B0 40%, #7C84BF 65%, #B8BCE0 85%, #FFFFFF 100%)' }} data-testid="community-rewards-section">
    <div className="max-w-5xl mx-auto text-white">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 mb-3 px-4 py-1.5 bg-white/10 rounded-full">
          <Users className="w-4 h-4 text-[#8B9AD4]" />
          <span className="text-sm font-medium text-white/80">Built by the Community</span>
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold mb-3 text-white">
          Share What Worked. Get Recognized.
        </h2>
        <p className="text-white/60 text-sm sm:text-base max-w-lg mx-auto">
          Your experience can help others choose better skincare products.
          Contribute reviews, votes, and routines — and build your reputation in the community.
        </p>
      </div>

      {/* Featured contributor spotlight */}
      <div className="flex justify-center mb-10">
        <div className="rounded-2xl bg-white max-w-lg w-full relative overflow-hidden" style={{ boxShadow: '0 0 0 2px rgba(74,85,166,0.3), 0 0 20px 4px rgba(107,91,168,0.25), 0 0 40px 8px rgba(168,124,180,0.15)' }} data-testid="featured-contributor">
          {/* Gradient highlight bar */}
          <div className="h-[6px] w-full" style={{ background: 'linear-gradient(90deg, #8B9AD4, #A87CB4, #D4A0C4)' }} />
          <div className="flex items-center gap-5 px-6 py-4">
          {/* Avatar */}
          <div className="relative shrink-0">
            <div className="w-16 h-16 rounded-full p-[2.5px]" style={{ background: 'linear-gradient(135deg, #4A55A6, #8B6BAE, #A87CB4)' }}>
              <img
                src="https://static.prod-images.emergentagent.com/jobs/7ee131c6-4bab-4dd1-83de-596734e4340a/images/376cd07fcd01f09d520486e1b78a700c4eaa1a03dd8451103b7ca8ebd085edb2.png"
                alt="Ananya"
                className="w-full h-full rounded-full object-cover border-2 border-white"
              />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-sm font-bold text-foreground">Ananya D.</span>
              <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-[#4A55A6]/10 text-[#4A55A6]">Top Contributor</span>
            </div>
            <p className="text-xs text-muted-foreground mb-2">42 routines shared · 180+ community votes</p>
            <div className="flex gap-1.5">
              <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-[#4A55A6]/10 text-[#4A55A6]">Routine Pro</span>
              <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-[#4A55A6]/10 text-[#4A55A6]">Trusted Voter</span>
              <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-[#4A55A6]/10 text-[#4A55A6]">Skin Mentor</span>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {cards.map((c, i) => (
          <div
            key={c.title}
            className="rounded-2xl bg-white border border-white/80 p-6 hover:shadow-lg transition-all shadow-sm"
            data-testid={`reward-card-${i}`}
          >
            <div className="w-12 h-12 rounded-xl bg-[#4A55A6]/10 flex items-center justify-center mb-4">
              <c.icon className="w-6 h-6 text-[#4A55A6]" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-gradient-brand">{c.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">{c.description}</p>
            <div className="mt-auto">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#4A55A6]/10 border border-[#4A55A6]/20 text-xs font-semibold text-[#4A55A6]">
                <ArrowRight className="w-3 h-3" /> {c.footer}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link to="/upload">
          <Button variant="secondary" className="rounded-full gap-2 bg-[#2D2D2D] text-white hover:bg-[#1A1A1A]" data-testid="join-earn-btn">
            Share Your Experience <ArrowRight className="w-4 h-4" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
);
